import { AppConfig } from "../Config";
import constant from "../_config/constant";
import { clearBrowserSession } from '@crewmates/api-client-legacy';
import * as moment from "moment-timezone";

export function processMediaUrl(inputString) {
  const urlRegex = /^(?:https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
  if (urlRegex.test(inputString)) {
    return inputString; // It's already a URL, return as is
  } else {
    const resultUrl = `${AppConfig.s3Endpoint}media/${inputString}`;
    return resultUrl;
  }
}

export function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (data.statusCode == 401 || data.statusCode == 403) {
      clearBrowserSession();
      window.location.replace("/");
    }
    if (data.statusCode != 200 && data.statusCode != "201") {
      const error = (data && (data.message || data.userMessage)) || response.statusText || 'Request failed';
      return Promise.reject(error);
    }
    return data;
  });
}

export const getFormattedDate = (dd) => {
  let date = new Date(dd).getDate()
  let month = new Date(dd).getMonth() + 1
  let year = new Date(dd).getFullYear()

  if (date < 10) date = `0${date}`
  if (month < 10) month = `0${month}`
  return `${year}-${month}-${date}`
}

export const getTommorow = () => {
  const tommorow = new Date()
  tommorow.setDate(new Date().getDate() + 1)

  return getFormattedDate(tommorow)
}

export function convertToTimezone(date, targetTimezone) {
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const milliseconds = date.getMilliseconds();

  return moment.tz([year, month, day, hours, minutes, seconds, milliseconds], targetTimezone);
}

export function creditCardType(brand) {
  switch(brand.toLowerCase()){
    case 'visa' : return 'VISA';
    case 'american express': return 'AMEX';
    case 'mastercard': return 'MASTERCARD';
    default: return 'UNDEFINED';
  }
}

export function creditCardTypeAsset(brand) {
  const brandImageName = creditCardType(brand)
  return `/images/card/${brandImageName}.png`
}

export function flattenArray(arr, depth = 1) {
  if (depth === 0) return arr;
  
  return arr.reduce((acc, item) => {
    if (Array.isArray(item)) {
      acc.push(...flattenArray(item, depth - 1));
    } else {
      acc.push(item);
    }
    return acc;
  }, []);
}

// Group items into batches bounded by count and, when a byte budget is supplied, by total
// size. Without the byte budget a batch can satisfy a file-count limit and still be far too
// large for the receiving endpoint, which is how ten within-limit photos add up to a
// rejected 60 MB request.
function buildBatches(items, batchSize, maxBytes, sizeOf) {
  const useBytes = Number.isFinite(maxBytes) && maxBytes > 0 && typeof sizeOf === 'function';
  const batches = [];
  let current = [];
  let currentBytes = 0;

  items.forEach(item => {
    const size = useBytes ? Number(sizeOf(item)) || 0 : 0;
    // An item bigger than the whole budget still ships alone - it cannot be split here,
    // and the caller is expected to have rejected oversized items already.
    const exceedsCount = current.length >= batchSize;
    const exceedsBytes = useBytes && current.length > 0 && currentBytes + size > maxBytes;
    if (exceedsCount || exceedsBytes) {
      batches.push(current);
      current = [];
      currentBytes = 0;
    }
    current.push(item);
    currentBytes += size;
  });

  if (current.length) batches.push(current);
  return batches;
}

export async function batchProcess(array, batchSize, processFn, options = {}) {
  const { delay = 0, onProgress, maxBytes, sizeOf } = options;
  const items = [...(array || [])];
  const batches = buildBatches(items, batchSize, maxBytes, sizeOf);
  const results = [];
  let itemsProcessed = 0;

  for (let index = 0; index < batches.length; index += 1) {
    const batch = batches[index];
    const batchNumber = index + 1;

    const result = await processFn(batch, batchNumber);
    results.push(result);
    itemsProcessed += batch.length;

    if (onProgress) {
      onProgress({
        batchNumber,
        totalBatches: batches.length,
        itemsProcessed,
        totalItems: items.length,
        progress: items.length ? Math.min((itemsProcessed / items.length) * 100, 100) : 100
      });
    }

    if (delay > 0 && batchNumber < batches.length) {
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }

  return results;
}

export function simpleHash(str, length = 32) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  
  let result = Math.abs(hash).toString(16);
  while (result.length < length) {
    result += Math.abs(hash * result.length).toString(16);
  }
  
  return result.substring(0, length);
}
